import { useCallback, useState, useEffect } from "react";
import { AppAPIService } from "../../../../../../../services/AppAPIService";

const emptyState = { data: null, isLoading: true, isFetched: false, error: null };
export default function useFetchData({ queryParams }) {
  const api = AppAPIService.getInstance();
  const [state, setState] = useState(emptyState);
  const [revision, setRevision] = useState(0);
  const params = new URLSearchParams(queryParams).toString();
  const refetch = useCallback(() => setRevision(value => value + 1), []);
  useEffect(() => {
    let active = true;
    setState(emptyState);
    const fetchData = async () => {
      try {
        const data = await api.makeHttpRequest({ url: `/publications?${params}`, method: "GET" });
        if (!active) return;
        if (data?.upstreamUnavailable || !Array.isArray(data?.data)) {
          throw new Error("PUBLICATIONS_UNAVAILABLE");
        }
        setState({ data, isLoading: false, isFetched: true, error: null });
      } catch (_) {
        if (active) setState({ data: null, isLoading: false, isFetched: true,
          error: "Não foi possível consultar as publicações. Tente novamente. Se o problema continuar, procure o suporte." });
      }
    };
    fetchData();
    return () => { active = false; };
  }, [api, params, revision]);
  return { ...state, refetch };
}
